// extracted by mini-css-extract-plugin
export default {"root":"profit-badge_root__pjVIs","label":"profit-badge_label__JayjN","value":"profit-badge_value__LBL03"};